import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import React, { useEffect, useState } from "react";
import '../../../../cssfiles/homepage.css';
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import { useSelector } from 'react-redux';

export default function AssetMaintenanceTablewidget(props){
    //console.log("IN Tablewidget I AM IN");
    const tagaliascollectionvaluesnewjson = useSelector((state) => state.mainpagedata.tagaliascollectionvaluesnewjson);
    const tagcollectionvaluesnewjson = useSelector((state) => state.mainpagedata.tagcollectionvaluesnewjson);
    const devicedetails = useSelector((state) => state.mainpagedata.devicedetailsobject)
    const tagcollectionvalue = useSelector((state) => state.mainpagedata.tagcollectionvalues)
    //console.log("Tablewidget insi now operate**********************tagcollectionvalue********************",tagcollectionvalue)
    const sdate_edate_selected = useSelector((state) => state.mainpagedata.selecteddates)
    
    var dataobject = {};
    
    //Generic variables
    const [table_head, setTableHead] = useState([]);
    const [table_rows, setTableRows] = useState([]);


    function formattedDate(Timestamp){
        const timedate = new Date(Number(Timestamp)*1000);
        var timedateyear = timedate.getFullYear();
        var timedateyear = timedateyear + "";
        if(timedateyear.length < 4){
            while(timedateyear.length < 4){
                timedateyear = "0"+timedateyear
            }
        }

        var timedatemonth = timedate.getMonth()+1;
        var timedatemonth = timedatemonth + "";
        if(timedatemonth.length < 2){
            while(timedatemonth.length < 2){
                timedatemonth = "0"+timedatemonth
            }
        }

        var timedatedaydate = timedate.getDate();
        var timedatedaydate = timedatedaydate + "";
        if(timedatedaydate.length < 2){
            while(timedatedaydate.length < 2){
                timedatedaydate = "0"+timedatedaydate
            }
        }

        var timedatehour =  timedate.getHours();
        var timedatehour = timedatehour + "";
        if(timedatehour.length < 2){
            while(timedatehour.length < 2){
                timedatehour = "0"+timedatehour
            }
        }

        var timedateminute =  timedate.getMinutes();
        var timedateminute = timedateminute + "";
        if(timedateminute.length < 2){
            while(timedateminute.length < 2){
                timedateminute = "0"+timedateminute
            }
        }
        
        var timedatesec =  timedate.getSeconds();
        var timedatesec = timedatesec + "";
        if(timedatesec.length < 2){
            while(timedatesec.length < 2){
                timedatesec = "0"+timedatesec
            }
        }

        var timedatemsec =  timedate.getMilliseconds();
        var timedatemsec = timedatemsec + "";
        if(timedatemsec.length < 3){
            while(timedatemsec.length < 3){
                timedatemsec = "0"+timedatemsec
            }
        }

        var timedateoveralldate = timedateyear+"-"+timedatemonth+"-"+timedatedaydate+" "+timedatehour+":"+timedateminute+":"+timedatesec+"."+timedatemsec;
        return timedateoveralldate;
    }


    useEffect(() => { 

        var head_values = [];
        head_values.push("Asset Name");
        var tagproperties = props.widgetprop.props.extended.tagprops;
        var rows_values = [];

        var maintenance_config = tagcollectionvaluesnewjson["maintenanceconfig"]?.maintenanceObject;

        if(maintenance_config != undefined && maintenance_config != null){
            const firstKey = Object.keys(maintenance_config)[0];

            for (const key in maintenance_config[firstKey]) {
                head_values.push(key);
            }
    
            for(const keydata in maintenance_config){
                var currentobject = maintenance_config[keydata];
                var rowarray = [];
    
                rowarray.push(devicedetails[keydata].Name);
                for(const nestedkey in currentobject){
                    var value =  currentobject[nestedkey]
                    if((nestedkey == "Last Maintenance Date") || (nestedkey == "Next Maintenance Date")){
    
                        console.log("nestedkey",nestedkey,"value",value)
                        if(value != null   && value != undefined && value != ''){
                            value = formattedDate(value);
                        }else{
                            value = "Not Available"
                        }
                    }
                    rowarray.push(value)
                }
                console.log("rowarray",rowarray)
                rows_values.push(rowarray);
            }
    
            setTableHead(head_values)
            setTableRows(rows_values)
        }
        

        // //console.log("head_values in tablewidget ",head_values)
        // tagproperties.map((tagprops, index)=>{
        //     //console.log("current tagprops",tagprops)
        //     var rowname = tagprops.tagname;
        //     var tagid = tagprops.tagid;
        //     var singlerowdata = [];
            
        //     //console.log("tagprops.calculation.calculation_operations_list in table ",tagprops.calculation.calculation_operations_list)
        //     for(let keyname in tagprops.calculation.calculation_operations_list){
                
        //         var currrowvalue = tagprops?.calculation.calculation_operations_list[keyname].operand_1;
        //         var currenttagid = tagprops?.taginformationrequired[currrowvalue]?.tagid;
        //         //console.log("HERES IN tagprops.calculation.calculation_operations_list-currrowvalue",currrowvalue)
        //         //console.log("HERES IN tagprops.calculation.calculation_operations_list-currenttagid",currenttagid)

        //         var accessrowvalue = rowname +"."+currrowvalue;
        //         //console.log("HRE IN tagprops.calculation.calculation_operations_list in table--------------- in Tablewidget",tagprops.calculation.calculation_operations_list,"currrowvalue----",currrowvalue,"accessrowvalue----",accessrowvalue,"tagcollectionvalue[accessrowvalue]",tagcollectionvalue[accessrowvalue],"currrowvalue Tablewidget", currrowvalue," accessrowvalue Tablewidget", accessrowvalue)
        //         //console.log("")
        //         //console.log("")
        //         //console.log("in Table widget tagcollectionvalue[rowname+:+currrowvalue+:+currenttagid]",tagcollectionvalue[rowname+":"+currrowvalue+":"+currenttagid],"index",index)
        //         if(typeof tagcollectionvalue[rowname+":"+currrowvalue+":"+currenttagid] === "number"){
        //             var currcellvalue=tagcollectionvalue[rowname+":"+currrowvalue+":"+currenttagid];
        //             //console.log("Numerical Values in Tablewidget-currcellvalue",currcellvalue)
        //             singlerowdata.push(Number(currcellvalue).toFixed(2))
        //         }else{
        //             singlerowdata.push(tagcollectionvalue[rowname+":"+currrowvalue+":"+currenttagid])
        //         }
                
        //     }

        //     rows_values.push(singlerowdata)
        // })

        // //console.log("//////rows_values/////////-Tablewidget-rows_values",rows_values,"rows_values",rows_values)
        // switch(props.widgetprop.widgetname)
        // {
        //     case 'Total Harmonic Details(%)':
        //         //console.log("head_tod_values",head_values)
        //         //console.log("rows_tod_values",rows_values)
        //         setTableHead(head_values)
        //         setTableRows(rows_values)
        //         break
        //     case 'TOD':
        //         //console.log("head_tod_values TOD",head_values)
        //         //console.log("rows_tod_values TOD",rows_values)
        //         setTableHead(head_values)
        //         setTableRows(rows_values)
        //         break
        //     case 'Energy Budgeting (kWh)':
        //         //console.log("head_tod_values-Energy Budgeting",head_values)
        //         //console.log("rows_tod_values-Energy Budgeting",rows_values)
        //         setTableHead(head_values)
        //         setTableRows(rows_values)
        //         break
        //     case 'Cost Budgeting (INR)':
        //         setTableHead(head_values)
        //         setTableRows(rows_values)
        //         break
        //     case 'Community Engagement':
        //         setTableHead(head_values)
        //         setTableRows(rows_values)
        //         break
        //     case 'Upcoming Maintenance':
        //         setTableHead(head_values)
        //         setTableRows(rows_values)
        //         break
        //     case 'Gateway List':
        //         setTableHead(head_values)
        //         setTableRows(rows_values)
        //         break
        //     case 'Asset List':
        //         setTableHead(head_values)
        //         setTableRows(rows_values)
        //         break
        //     case 'Parameter Data':
        //         setTableHead(head_values)
        //         setTableRows(rows_values)
        //         break
           
        // }
    }, [props.widgetprop, sdate_edate_selected,tagcollectionvaluesnewjson, tagaliascollectionvaluesnewjson]);
        
       
        // function Rows({ row_value }) {
        //     const value = row.split("\n"); 
        // }

        function BreakLine({ value }) {
            const breaklines = value.split("\n");
          
            return (
              <List sx={{padding:'4px 0px 4px 0px'}}>
                {breaklines.map((line, i) => (
                  <ListItem sx={{padding:'2px 0px 2px 0px'}} key={i}>{line}</ListItem>
                ))}
              </List>
            );
          }

          return(
            <>
            {/*//console.log("table_rows in initialized",table_rows)*/}
            {(table_rows.length > 0 ) && ( 
                
                <TableContainer component={Paper} sx={{ width: '100%', height:"100%",paddingLeft:'0px',backgroundColor:'var(--secondary-backgroundLK)',paddingRight:'0px' }} elevation={0}>
                <Table sx={{ width: '100%' }} size="small">
                    {
                           <TableHead>
                                    <TableRow sx={{border:"0px"}}>
                                    {table_head.map((table_head_value) => 
                                    (
                                        
                                        <TableCell sx={{
                                                        fontSize:props.widgetprop.props.extended.tablehead.fontsize,
                                                        fontWeight:props.widgetprop.props.extended.tablehead.fontweight,color:"var(--grey-variation-tableLK)"
                                                      }}>{table_head_value}
                                                      </TableCell>
                                    ))}
                                    </TableRow>
                                </TableHead>
                            
                        
                    }
                    {/*console.log("table_rows here",table_rows)*/}
                    <TableBody>
                        {table_rows.map((row,index) => (
                            <TableRow
                                key={index}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 },height:"6px",'& > *': { borderBottom: "1px solid var(--table-boarder-line)" } }}
                            >   
                                {row.map((row_value, row_index)=>(
                                                                                    
                                                    <TableCell component="th" scope="row" sx={{fontSize:props.widgetprop.props.extended.tablerows.fontsize,
                                                        fontWeight:props.widgetprop.props.extended.tablerows.fontweight,color: (row_value === 'Connected' || row_value === 'ON TARGET') ? '#00943D' : (row_value === 'Disconnected' || row_value === 'DEVIATED BY 3%') ? '#DC272D' : 'var(--grey-variation-tablerowsLK)'}} >
                                                                {/*(row_value.includes('\n'))?<BreakLine value={row_value}/>:row_value*/}
                                                                {row_value}                                                
                                                    </TableCell>        
                                ))}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>)}
            </>
        )
    
}


/*
{(row_index==1 && props.widgetprop.widgetname=='TOD')?<BreakLine value={row_value}/>:row_value}


                                                        {row_value.includes('\n')?<BreakLine value={row_value}/>:row_value}

*/ 